import { render, staticRenderFns } from "./NoteTextarea.vue?vue&type=template&id=7c71777c&scoped=true&"
import script from "./NoteTextarea.vue?vue&type=script&lang=js&"
export * from "./NoteTextarea.vue?vue&type=script&lang=js&"
import style0 from "./NoteTextarea.vue?vue&type=style&index=0&id=7c71777c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c71777c",
  null
  
)

export default component.exports